import { SimplexNoise } from "three/examples/jsm/math/SimplexNoise";

// Seeded PRNG based on the mulberry32 algorithm. Given the same seed it always produces the
// same sequence of numbers, which is required for deterministic grass placement per chunk.
// Exported so grassWorker.js can import it and use it with a per-chunk seed.
export function mulberry32(seed) {
    return function () {
        let t = seed += 0x6D2B79F5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}

// ============ TERRAIN CONFIGURATION ============
// Change these values to modify terrain generation
// Both main thread and workers will use these values

export const TERRAIN_SEED = 12345;
export const NOISE_SCALE = 400;
export const NOISE_AMPLITUDE = 12.5;
export const GRASS_Y_OFFSET = -0.20;

export const flatAreas = [
    { x: 1200, z: 950, size: 250 },  // factory area
    { x: 385, z: -300, size: 120 },  // powerlines
];

// ============ SHARED SIMPLEX INSTANCE ============
// SimplexNoise expects an object with .random() method (like Math)
const seededRandom = { random: mulberry32(TERRAIN_SEED) };
export const simplex = new SimplexNoise(seededRandom);

// ============ SHARED FUNCTIONS ============
export function smoothstep(edge0, edge1, x) {
    let t = Math.max(0, Math.min(1, (x - edge0) / (edge1 - edge0)));
    return t * t * (3 - 2 * t);
}

export function getHeight(x, z) {
    let roughTerrain = NOISE_AMPLITUDE * simplex.noise(x / NOISE_SCALE, z / NOISE_SCALE);
    let smoothTerrain = 0.0;

    let blendFactor = 1;

    for (let area of flatAreas) {
        let distanceX = Math.abs(x - area.x);
        let distanceZ = Math.abs(z - area.z);
        let transitionSize = area.size * 0.25;

        let factorX = smoothstep(area.size - transitionSize, area.size + transitionSize, distanceX);
        let factorZ = smoothstep(area.size - transitionSize, area.size + transitionSize, distanceZ);

        let areaBlend = Math.min(factorX, factorZ);
        blendFactor = Math.min(blendFactor, areaBlend);
    }

    return roughTerrain * blendFactor + smoothTerrain * (1 - blendFactor);
}
